import {mapMutations} from 'vuex';

export default {
    methods: {
        ...mapMutations('breadcrumb', {
                setBreadcrumbs: 'SET_BREADCRUMB',
                pushBreadcrumb: 'PUSH_BREADCRUMB',
                popBreadcrumb: 'POP_BREADCRUMB',
                emptyBreadcrumbs: 'EMPTY_BREADCRUMB',
                setCurrentBreadcrumb: 'SET_CURRENT_BREADCRUMB',
                removeCurrentBreadcrumb: 'REMOVE_CURRENT_BREADCRUMB',
                removeFromIndex: 'REMOVE_FROM_INDEX',
            },

        ),
        handleTabsBreads(breads){
            // this.removeCurrentBreadcrumb();
            this.removeFromIndex(breads[0])
            breads.forEach(b => {
                this.pushBreadcrumb(b)

            })
            this.setCurrentBreadcrumb(breads)
        }
    }
}
